import React from "react";
import { Button } from "react-bootstrap";
import autoBind from "react-autobind";
import _ from "lodash";

import PlayerItemValueReadOnly from "./PlayerItemValueReadOnly";
import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";
import { getSelectedStyles, getPrefixedStyles} from "../../utils/utils";
class PlayerYesNo extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		autoBind(this);
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	onClick(event, value) {
		if (this.props.onSubmit) { this.props.onSubmit(value); }
	}

	renderReadOnly() {
		return (
			<PlayerItemValueReadOnly item={this.props.item} />
		);
	}

	renderEditable() {

		const { item, getImage, getVideo, getPdf, listIndex, sectionIndex, itemIndex, disabled } = this.props;
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const yesNoItemTheme = _.get(theme, "item.yesNo");

		let yesSelected = false;
		let noSelected = false;
		let naSelected = false;
		const hasValue = !_.isEmpty(item.value);
		if (hasValue) {
			switch (item.value) {
				case "yes": {
					yesSelected = true;
					break;
				}
				case "no": {
					noSelected = true;
					break;
				}
				case "n/a": {
					naSelected = true;
					break;
				}
				default: { }
			};
		}

		let yesStyles = _.assign(yesNoItemTheme.yesButton,getSelectedStyles(yesNoItemTheme.yesButton, yesSelected));
		if (!yesSelected && hasValue) {
			yesStyles = _.assign({}, yesStyles, getPrefixedStyles(yesNoItemTheme.yesButton, "disabled"));
		} 
		let noStyles = _.assign(yesNoItemTheme.noButton,getSelectedStyles(yesNoItemTheme.noButton, item.value === "no"));
		if (!noSelected && hasValue) {
			noStyles = _.assign({}, noStyles, getPrefixedStyles(yesNoItemTheme.noButton, "disabled"));
		} 
		let naStyles = _.assign(yesNoItemTheme.naButton,getSelectedStyles(yesNoItemTheme.naButton, item.value === "n/a"));
		if (!naSelected && hasValue) {
			naStyles = _.assign({}, naStyles, getPrefixedStyles(yesNoItemTheme.naButton, "disabled"));
		} 

		const buttonContainerStyle = { margin: "20px 20px 15px 20px" };
		const component = <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			<div style={{ display: "flex", flexDirection: "column", width: "100%", overflowX: "auto" }}>
				<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
				<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
				{getImage()}
				{getVideo()}
				{getPdf()}
				<div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
					<div style={buttonContainerStyle}>
						<Button disabled={disabled} onClick={(e) => this.onClick(e, "yes")} style={yesStyles}>Yes</Button>
					</div>
					<div style={buttonContainerStyle}>
						<Button disabled={disabled} onClick={(e) => this.onClick(e, "no")} style={noStyles}>No</Button>
					</div>
					{this.props.item.hasOwnProperty("yesNoShowNa") && this.props.item.yesNoShowNa && <div style={buttonContainerStyle}>
						<Button disabled={disabled} onClick={(e) => this.onClick(e, "n/a")} style={naStyles}>N/A</Button>
					</div>
					}
				</div>
			</div>
		</div>;
		return component;
	}
}

export default withPlayerItemHoc(PlayerYesNo);